<template>
  <v-container fluid fill-height class="d-flex align-center justify-center">
    <v-card flat class="card-bg rounded-20 mt-5 pb-5">
      <v-toolbar class="transparent" flat dense>
        <v-toolbar-title class="title-font"> UNPAID INVOICES </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-0">
        <small class="title-font"
          >Please pay any overdue invoices to regain access to the
          platform</small
        >
      </v-card-text>

      <v-card flat class="mx-4 rounded-10">
        <v-card-text v-if="loading" class="text-center">
          <v-progress-circular indeterminate color="primary" />
        </v-card-text>
        <v-data-table
          :headers="headers"
          :items="_invoices || []"
          :items-per-page="5"
          v-if="!loading"
        >
          <template v-slot:[`header.url`]="{ header }">
            {{ header.text }}
            <v-tooltip top class="rounded-10">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-1 pb-1" v-bind="attrs" v-on="on"
                  >mdi-information</v-icon
                >
              </template>
              <span
                >Open to view payment details, download invoice and
                receipt.</span
              >
            </v-tooltip></template
          >
          <template v-slot:[`item.overdue`]="{ item }">
            <v-icon
              v-if="!item.paid && isOverdue(item)"
              color="error"
              class="ms-2"
              >mdi-alert-circle</v-icon
            > </template
          ><template v-slot:[`item.invoice_number`]="{ item }">
            <div style="white-space: nowrap">
              <v-tooltip top class="rounded-10">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="ml-n1 px-1"
                    @click="openDetail(item)"
                  >
                    {{ item.invoice_number }}
                  </v-btn>
                </template>
                <span> Click to view details. </span>
              </v-tooltip>
              <v-tooltip top class="rounded-10">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="!item.paid"
                    color="warning"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-alert
                  </v-icon>
                </template>
                <span> This invoice has not been paid. </span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.invoiced_at`]="{ item }">
            {{ item.invoiced_at | luxon({ output: "date_short" }) }}
          </template>
          <template v-slot:[`item.due_date`]="{ item }">
            {{
              new Date(item.due_date).toISOString()
                | luxon({ output: "date_short" })
            }}
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            $ {{ item.amount }}
          </template>
          <template v-slot:[`item.pdf`]="{ item }">
            <a :href="item.pdf">PDF</a>
          </template>
          <template v-slot:[`item.url`]="{ item }">
            <a :href="item.url" target="_blank">Open Payment Page</a>
            <v-icon class="ml-1 pb-2" color="primary" x-small>
              mdi-open-in-new
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
      <v-card-text class="pb-0">
        <small class="title-font"
          >Access will regained within 60 seconds of paying all overdue
          invoices.</small
        >
      </v-card-text>
    </v-card>
    <InvoiceDetailDialog
      v-model="dialog"
      :invoice="selectedInvoice"
      :arrears="true"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import InvoiceDetailDialog from "./shared/InvoiceDetailDialog.vue"

export default {
  name: "ArrearsPage",

  components: { InvoiceDetailDialog },

  data() {
    return {
      loading: false,
      dialog: false,
      selectedInvoice: null,
      headers: [
        {
          text: "Overdue",
          value: "overdue"
        },
        {
          text: "Invoice ID",
          value: "invoice_number"
        },
        {
          text: "Issued",
          value: "invoiced_at"
        },
        {
          text: "Due",
          value: "due_date"
        },
        {
          text: "Amount (ex. Tax)",
          value: "amount"
        },
        {
          text: "Download (PDF)",
          value: "pdf"
        },
        {
          text: "Payment Page",
          value: "url"
        }
      ]
    }
  },

  watch: {
    invoices(val, prevVal) {
      if (prevVal === null && val) this.loading = false
      if (Array.isArray(val)) this.checkForPayment()
    }
  },

  computed: {
    ...mapGetters(["invoices", "inArrears", "entryRoute"]),

    _invoices() {
      return this.invoices
        .filter((i) => i.due_date && i.amount > 0 && !i.paid)
        .sort((a, b) => new Date(a.due_date) - new Date(b.due_date))
    }
  },

  methods: {
    ...mapActions(["triggerReload"]),

    isOverdue(item) {
      return new Date(item.due_date) < new Date()
    },

    checkForPayment() {
      if (this.invoices.every((i) => !(!i.paid && this.isOverdue(i)))) {
        let entry = null
        if (this.entryRoute.name !== "arrearsPage") entry = this.entryRoute
        this.$router.push(entry || "inboxPage")
      }
    },

    openDetail(invoiceItem) {
      this.selectedInvoice = invoiceItem
      this.dialog = true
    }
  },

  mounted() {
    this.loading = true
    if (this.invoices) this.loading = false
    else this.triggerReload("invoices")
  }
}
</script>
